module.exports = "data:image/gif;base64,R0lGODlhBwAEAIABAEHEG2tqZyH5BAEAAAEALAAAAAAHAAQAAAIHjGEJq8sOCwA7"